"use client";

import { useState } from "react";
import MatchRecapModal from "./match-recap-modal";

interface FeedCardProps {
  matchNumber: number;
  children: React.ReactNode;
  isDeadlock?: boolean;
}

// Clickable wrapper for a match history card
export function MatchFeedCard({ matchNumber, children, isDeadlock = false }: FeedCardProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={`w-full text-left rounded-xl p-3 shadow-sm transition cursor-pointer group select-none ${
          isDeadlock
            ? "bg-amber-50 border border-amber-200 hover:border-amber-400"
            : "bg-white border border-purple-100 hover:border-purple-300"
        }`}
        style={{ WebkitUserSelect: "none", userSelect: "none" }}
      >
        {children}
        <div className={`mt-2 pt-1.5 text-[10px] font-semibold ${
          isDeadlock ? "text-amber-400" : "text-purple-200"
        } group-hover:${isDeadlock ? "text-amber-500" : "text-purple-400"} transition`}>
          Tap for recap →
        </div>
      </button>

      {open && (
        <MatchRecapModal
          matchNumber={matchNumber}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}

// Desktop tile variant (flex-1 sizing, used in the wrapping flex grid)
export function MatchFeedTile({ matchNumber, children, isDeadlock = false }: FeedCardProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={`text-left rounded-xl p-3 min-w-[160px] flex-1 shadow-sm transition cursor-pointer group select-none ${
          isDeadlock
            ? "bg-amber-50 border border-amber-200 hover:border-amber-400"
            : "bg-white border border-purple-100 hover:border-purple-200"
        }`}
        style={{ WebkitUserSelect: "none", userSelect: "none" }}
      >
        {children}
        <div className={`mt-1.5 text-[10px] font-semibold ${
          isDeadlock ? "text-amber-300" : "text-purple-200"
        } group-hover:${isDeadlock ? "text-amber-500" : "text-purple-400"} transition`}>
          Tap for recap →
        </div>
      </button>

      {open && (
        <MatchRecapModal
          matchNumber={matchNumber}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
